export default {
  init() {
    // JavaScript to be fired on the home page

    var changeHeaderImage = function () {
      if(jQuery(window).width() < 991){
        $('.brand-div').find('img').attr('src','/wp-content/uploads/Logo_Rest.png');
      } else {
        $('.brand-div').find('img').attr('src','/wp-content/uploads/Logo_Startseite.png');
      }
    };
    changeHeaderImage();

    jQuery(window).resize(changeHeaderImage);
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js